// Valores da coluna "Estágio" do documento estagios-da-cultura.
export const cultureStages = [
  "Pré-plantio",
  "Plantio / Semeadura",
  "Germinação",
  "Emergência",
  "Estabelecimento inicial",
  "Desenvolvimento vegetativo inicial",
  "Desenvolvimento vegetativo",
  "Desenvolvimento vegetativo avançado",
  "Perfilhamento",
  "Alongamento / Elongação",
  "Formação de estruturas reprodutivas",
  "Botonização",
  "Pré-floração",
  "Floração inicial",
  "Plena floração",
  "Final de floração",
  "Pegamento / Frutificação inicial",
  "Desenvolvimento dos frutos",
  "Enchimento de grãos / frutos",
  "Maturação",
  "Maturação fisiológica",
  "Pré-colheita",
  "Colheita",
  "Pós-colheita",
  "Senescência",
  "Dormência / Repouso vegetativo",
  "Brotação / Reinício vegetativo",
  "Rebrota",
  "Pós-poda",
  "Pós-corte",
];
